<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p><span>利用規約</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3 v-if="brand"><span>ブランド利用規約</span></h3>
                <h3 v-if="showroom"><span>ショールーム利用規約</span></h3>
                <h3 v-if="shop"><span>ショップ利用規約</span></h3>
            </div>

            <!--item-->
            <div class="item-wrap">
                <div class="item form_text">
                    <Step0Brand v-if="brand"/>
                    <Step0ShowRoom v-if="showroom"/>
                    <Step0Shop v-if="shop"/>
                </div>
            </div>

            <div class="item form_checkbox question-wrap _t-center">
                <input type="checkbox" name="approval-btn" class="" id="approval-btn" v-on:click="isDisabled = !isDisabled">
                <label for="approval-btn">
                    <div class="check-mark"><span class=""></span></div>
                    <span>同意する</span>
                </label>
            </div>
        </div>

        <div class="control-wrap">
            <button v-if="shop" type="button" class="_left js-swiper-prev" v-on:click="$emit('showPrevSwiper')"><span>Back</span></button>
            <button v-if="brand || showroom" type="button" class="_left js-swiper-prev" disabled><span></span></button>

            <button v-on:click="showNextSwiper" v-bind:disabled="isDisabled" type="button" v-bind:class="isDisabled? '_left' : '_right'" class="js-swiper-next"><span>Next</span></button>
        </div>

    </div>
</div>
</template>
<style>
input:not(:focus)::-webkit-input-placeholder {
	color: transparent;
}
input:not(:focus)::-moz-placeholder {
	color: transparent;
}
input:not(:focus)::-ms-input-placeholder {
	color: transparent;
}
input:not(:focus)::placeholder {
	color: transparent;
}
</style>

<script>
    import Step0Brand from '@/components/EndUser/MembershipRegistrationShopStep/Step0Brand'
    import Step0ShowRoom from '@/components/EndUser/MembershipRegistrationShopStep/Step0ShowRoom'
    import Step0Shop from '@/components/EndUser/MembershipRegistrationShopStep/Step0Shop'

    export default {
        components: {
            Step0Brand,
            Step0ShowRoom,
            Step0Shop,
        },
        data() {
            return {
                isDisabled: true,
            }
        },
        methods: {
            showNextSwiper() {
                this.$emit('showNextSwiper');
            },
        },
        computed: {
            shop() {
                return location.pathname.match(/^\/registration\/shop/);
            },
            brand() {
                return location.pathname.match(/^\/registration\/brand/);
            },
            showroom() {
                return location.pathname.match(/^\/registration\/showroom/);
            },
        }
    }
</script>
